<template>
  <div class="work-queue-chrome mb-6">
    <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
      <div class="mb-3 mb-md-0">
        <nav class="font-size-sm text-muted mb-1">
          <router-link class="text-muted" :to="{ path: '/workbench', query: { lane: 'posting' } }">
            Work Queue
          </router-link>
          <span v-for="(crumb, index) in crumbs" :key="index">
            <span class="mx-1">/</span>
            <router-link v-if="crumb.to" class="text-muted" :to="crumb.to">{{ crumb.label }}</router-link>
            <span v-else class="text-dark font-weight-bold">{{ crumb.label }}</span>
          </span>
        </nav>
        <div v-if="subtitle" class="text-muted font-size-sm">{{ subtitle }}</div>
        <div class="mt-1">
          <router-link class="font-size-sm font-weight-bold" to="/workbench-v2">
            Open Workbench 2.0
          </router-link>
        </div>
      </div>

      <form class="work-queue-search d-flex" @submit.prevent="onSearch">
        <input
          v-model="searchQuery"
          type="search"
          class="form-control form-control-solid mr-2"
          placeholder="Search client, policy number, or business number"
          aria-label="Search clients"
        />
        <button type="submit" class="btn btn-primary font-weight-bold text-uppercase">
          Search
        </button>
      </form>
    </div>

    <ul class="nav nav-tabs nav-tabs-line mb-0">
      <li v-for="lane in lanes" :key="lane.key" class="nav-item">
        <a
          href="#"
          class="nav-link"
          :class="{ active: activeLane === lane.key }"
          @click.prevent="selectLane(lane.key)"
        >
          {{ lane.label }}
          <span v-if="lane.count != null" class="label label-sm label-rounded label-light-primary ml-2">
            {{ lane.count }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "WorkQueueChrome",

  props: {
    activeLane: {
      type: String,
      default: "posting"
    },
    crumbs: {
      type: Array,
      default: () => []
    },
    subtitle: {
      type: String,
      default: null
    },
    laneCounts: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      searchQuery: ""
    };
  },

  computed: {
    lanes() {
      return [
        { key: "posting", label: "Posting", count: this.laneCounts.posting },
        { key: "maintenance", label: "Maintenance", count: this.laneCounts.maintenance },
        { key: "clients", label: "Clients", count: this.laneCounts.clients },
        { key: "brokers", label: "Producing Brokers", count: this.laneCounts.brokers }
      ];
    }
  },

  methods: {
    selectLane(lane) {
      this.$emit("lane", lane);
      this.$router.push({ path: "/workbench", query: { ...this.$route.query, lane } }).catch(() => {});
    },
    onSearch() {
      const q = String(this.searchQuery || "").trim();
      if (!q) return;
      this.$router
        .push({ path: "/workbench", query: { lane: "clients", q } })
        .catch(() => {});
      this.$emit("search", q);
    }
  }
};
</script>

<style lang="scss" scoped>
.work-queue-search {
  min-width: 280px;
  max-width: 480px;
  flex: 1;
}
.work-queue-search input {
  min-width: 200px;
}
</style>
